import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppPlatformService } from '../platform/app-platform.service';
import { ScreenOrientation } from '@capacitor/screen-orientation';
@Injectable({
  providedIn: 'root',
})
export class OrientationService {
  isLandscape: boolean = false;
  private isLandscapeSubject = new BehaviorSubject<boolean>(false);
  public isLandscape$: Observable<boolean> =
    this.isLandscapeSubject.asObservable();

  constructor(private appPlatformService: AppPlatformService) {
    this.initOrientationDetection();
  }

  private initOrientationDetection(): void {
    // Detectar orientación inicial
    this.checkOrientation();

    this.setupOrientationListener();
  }

  private async checkOrientation() {
    const clientWidth = document.documentElement.clientWidth;
    const clientHeight = document.documentElement.clientHeight;
    const devicePortraitWidth = clientWidth < clientHeight ? clientWidth : clientHeight;
    // console.log("devicePortraitWidth::",devicePortraitWidth,"w-h", clientWidth,  clientHeight)

    if (this.appPlatformService.isAppPlatform()) {
      // Para aplicaciones nativas con Capacitor
      const orientation = await ScreenOrientation.orientation();
      this.isLandscape = orientation.type.includes('landscape') && devicePortraitWidth < 600 && window.innerWidth < 1024;
    } else {
      // Para web
      this.isLandscape = window.innerWidth > window.innerHeight && devicePortraitWidth < 600 && window.innerWidth < 1024;
    }
    this.isLandscapeSubject.next(this.isLandscape);
  }

  // Configurar listener para cambios de orientación
  setupOrientationListener() {
    const clientWidth = document.documentElement.clientWidth;
    const clientHeight = document.documentElement.clientHeight;
    const devicePortraitWidth = clientWidth < clientHeight ? clientWidth : clientHeight;
    if (this.appPlatformService.isAppPlatform()) {
      // Para aplicaciones nativas con Capacitor
      ScreenOrientation.addListener(
        'screenOrientationChange',
        (orientation) => {
          this.isLandscape = orientation.type.includes('landscape') && devicePortraitWidth < 600 && window.innerWidth < 1024;
          this.isLandscapeSubject.next(this.isLandscape);
        }
      );
    } else {
      // También escuchar resize para web desktop
      window.addEventListener('resize', () => {
        const clientWidth = document.documentElement.clientWidth;
        const clientHeight = document.documentElement.clientHeight;
        const devicePortraitWidth = clientWidth < clientHeight ? clientWidth : clientHeight;
          this.isLandscape = window.innerWidth > window.innerHeight && devicePortraitWidth < 600 && window.innerWidth < 1024;
          this.isLandscapeSubject.next(this.isLandscape);
          // console.log("resize devicePortraitWidth::",devicePortraitWidth,"isLandscape:", this.isLandscape)
      });
    }
  }

  getCurrentOrientation(): boolean {
    return this.isLandscapeSubject.value;
  }
}
